export const PlusIcon: React.FC<any> = ({ className }) => {
  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{
        __html: `
         <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
          <path d="M12.3945 2.4707L12.3945 22.4707" stroke="white" stroke-width="3" stroke-linecap="round"/>
          <path d="M22.3945 12.4707L2.39453 12.4707" stroke="white" stroke-width="3" stroke-linecap="round"/>
        </svg>
    `,
      }}
    />
  );
};
